var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeakerphoneWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 7.99995C19.2956 7.99995 20.0587 8.31602 20.6213 8.87863C21.1839 9.44124 21.5 10.2043 21.5 11C21.5 11.7956 21.1839 12.5587 20.6213 13.1213C20.0587 13.6839 19.2956 14 18.5 14M10.5 7.99995V19C10.5 19.2652 10.3946 19.5195 10.2071 19.7071C10.0196 19.8946 9.76522 20 9.5 20H8.5C8.23478 20 7.98043 19.8946 7.79289 19.7071C7.60536 19.5195 7.5 19.2652 7.5 19V14M12.5 7.99995L17.024 4.22995C17.1555 4.12046 17.3154 4.0507 17.4851 4.02885C17.6548 4.00701 17.8271 4.03398 17.982 4.1066C18.1369 4.17922 18.2679 4.29449 18.3597 4.4389C18.4514 4.5833 18.5001 4.75087 18.5 4.92195V17.0779C18.5001 17.249 18.4514 17.4166 18.3597 17.561C18.2679 17.7054 18.1369 17.8207 17.982 17.8933C17.8271 17.9659 17.6548 17.9929 17.4851 17.971C17.3154 17.9492 17.1555 17.8794 17.024 17.7699L12.5 13.9999H4.5C4.23478 13.9999 3.98043 13.8946 3.79289 13.7071C3.60536 13.5195 3.5 13.2652 3.5 12.9999V8.99995C3.5 8.73473 3.60536 8.48038 3.79289 8.29284C3.98043 8.1053 4.23478 7.99995 4.5 7.99995H12.5Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeakerphoneWhite);
export default __webpack_public_path__ + "static/media/speakerphone-white.9ae03a7bba2bdd6754d31eb25e099256.svg";
export { ForwardRef as ReactComponent };